<script lang="ts">
  import InvalidFieldMessage from "./InvalidFieldMessage.svelte";
  
  export let placeholder: string | undefined = undefined;
  export let label: string | undefined = undefined;
  export let identifier: string;
  export let onChange: ((value: string) => void) | undefined = undefined;
  export let isLoading: boolean | undefined = undefined;
  export let isDisabled: boolean = false;
  export let value = "";
  export let invalidMessage: string | undefined = undefined;
  export let mask: string | undefined = undefined;
  export let type: "text" | "email" | "tel" | "number" = "text";
  export let inputProps: Record<string, unknown> = {};
  export let isMandatory: boolean = true;
  export let ignoreTabletW48: boolean = false;
  export let includeMargin: boolean = true;

  const handleChange = (e: Event) => {
    value = (e.target as HTMLInputElement).value;
    onChange && onChange(value);
  };

  $: showLoadingIndicator = isLoading;

  const inputClass = 'std-field__input font-MrEavesXLSanNarOT relative text-[20px] px-[14px] w-full h-[42px] bg-grey text-input border-solid border-transparent border-1 rounded-[8px] z-[10] outline-none laptop:h-[46px]'
</script>

<div class="relative w-full {ignoreTabletW48 ? '' : 'tablet:w-[48%]'}" class:mb-[26px]={includeMargin}>
  {#if label}
    <label
      for={identifier}
      class="font-MrEavesXLSanNarOTUltra relative text-[11px] inline-flex font-black text-primary mb-[4px] leading-[1.2] uppercase mobile:text-[12px] tablet:text-[12px] laptop:text-[15px]"
    >
      {label}
      {#if isMandatory}
        <span class="reg text-[0.7em] align-top">*</span>
      {/if}
    </label>
  {/if}
  <div class="relative">
    {#if showLoadingIndicator}
      <div class="absolute flex items-center justify-center top-6 left-4">
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
          <path fill="#ff6000" d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity="0.25"/>
          <path fill="#ff6000" d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z">
            <animateTransform attributeName="transform" dur="0.75s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12"/>
          </path>
        </svg>
      </div>
    {/if}
    {#if type === "text"}
      <input
        type="text"
        id={identifier}
        {placeholder}
        class:invalid-input={!!invalidMessage}
        class:is-loading={showLoadingIndicator}
        disabled={isDisabled}
        class={inputClass}
        data-testid={label}
        aria-label={label}
        {...inputProps}
        bind:value
        on:input={mask ? undefined : handleChange} />
    {:else if type === "number"}
      <input
        type="number"
        id={identifier}
        {placeholder}
        class:invalid-input={!!invalidMessage}
        class:is-loading={showLoadingIndicator}
        disabled={isDisabled}
        class={inputClass}
        data-testid={label}
        aria-label={label}
        {...inputProps}
        bind:value
        on:input={mask ? undefined : handleChange} />
    {:else if type === "email"}
      <input
        type="email"
        id={identifier}
        {placeholder}
        class:invalid-input={!!invalidMessage}
        class:is-loading={showLoadingIndicator}
        disabled={isDisabled}
        class={inputClass}
        data-testid={label}
        aria-label={label}
        {...inputProps}
        bind:value
        on:input={mask ? undefined : handleChange} />
    {/if}
  </div>
  <InvalidFieldMessage message={invalidMessage} />
</div>

<style>
  input.is-loading {
    padding-left: 2.5rem;
  }
</style>
